<template>
  <blockquote class="slide-in" :class="{'visible': visible }" v-if="quote && quote.text">
    <p v-accent="quote.text" class="text-l"></p>
    <cite class="accent text-xs" v-if="quote.author">
      {{ quote.author }}
    </cite>
  </blockquote>
</template>
<script>
export default {
  name: 'Blockquote',
  props: ['quote', 'visible']
}
</script>

<style scoped lang="scss">
blockquote {
  margin: 0 $gap-md;
  position: relative;
  max-width: 430px;

  @include screen ('md') {
    margin-left: 10%;
  } // END @include screen ('md');

  p {
    font: {
      style: italic;
      weight: bold;
    };
    line-height: 1.4em;
    margin: 0;
    padding: $gap-md 0;
    width: 100%;

    // &:before {
    //   content: "„";
    // }
    // &:after {
    //   content: "”";
    // }
  }

} // END blockquote;
cite {
  font: {
    style: normal;
    weight: 700;
  }
} // END cite;
</style>
